import logo from './logo.svg';
import './App.css';
import Stopwatch from "./components/Stopwatch";
import Countdown from "./components/Countdown";

/*

      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>

*/


function App() {
  return (
    
    <div className="App">
      <div className="App-title">Online Timers</div>
      <div className="Timers">
        <Stopwatch />
        <Countdown />
      </div>
    </div>
    
  );
}

export default App;
